import React from "react";
import "./About.css";
import { motion } from "framer-motion";

const textAnimation = {
  hidden: {
    opacity: 0,
    x: -100,
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 1,
      staggerChildren: 0.2,
    },
  },
};

const rightAnimation = {
  hidden: {
    opacity: 0,
    x: 120,
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 1,
    },
  },
};

export default function About() {
  return (
    <section className="about">

      {/* ================= Top Line ================= */}

      <div className="top-line">

        <motion.div
          className="diamond"
          initial={{ rotate: -45, scale: 0 }}
          whileInView={{ rotate: 45, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <span>02</span>
        </motion.div>

        <div className="line"></div>

        <motion.div
          className="about-tag"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          <div className="circle"></div>
          <p>About Us</p>
        </motion.div>

      </div>

      {/* ================= Main Content ================= */}

      <div className="about-container">

        {/* LEFT */}

        <motion.div
          className="left"
          variants={textAnimation}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          animate={{
            y: [0, -12, 0],
          }}
          transition={{
            duration: 6,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        >

          <motion.h1
            className="floating-title"
            animate={{ y: [0, -10, 0] }}
            transition={{
              duration: 5,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          >
            IDEAS,
          </motion.h1>

          <motion.h1
            className="floating-title"
            animate={{ y: [0, -16, 0] }}
            transition={{
              duration: 6,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          >
            STRATEGY, AND
          </motion.h1>

          <motion.h1
            className="floating-title"
            animate={{ y: [0, -12, 0] }}
            transition={{
              duration: 5.5,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          >
            RESULTS
          </motion.h1>

          <motion.h2
            className="floating-outline"
            animate={{ y: [0, -18, 0] }}
            transition={{
              duration: 7,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          >
            DELIVERED
          </motion.h2>

        </motion.div>

        {/* RIGHT */}

        <motion.div
          className="right"
          variants={rightAnimation}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
          >
            At <strong>Ignite Digital</strong>, we believe every successful
            business starts with a bold idea and the right digital strategy.
            We combine creativity, technology, and data-driven marketing to
            help brands grow, connect with their audience, and achieve
            measurable results.
          </motion.p>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
          >
            From building high-performing websites to creating impactful
            digital campaigns, we partner with businesses to deliver
            innovative solutions that inspire, engage, and convert.
            Every strategy is tailored to maximise growth and long-term
            success.
          </motion.p>

          <motion.h3
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.8 }}
          >
            We don't just build digital solutions—we ignite possibilities,
            accelerate growth, and turn ambitious ideas into lasting success.
          </motion.h3>

        </motion.div>

      </div>

    </section>
  );
}